export default {
  receiveCodeText: "انقر على زر 'احصل على الرمز' لتلقي رمز التحقق",
  voiceConfirm: "رمز التحقق الصوتي",
  receiveCode: "احصل على الرمز",
  securityConfirmText:
    "التحقق الأمني معطل حاليًا ولا تحتاج إلى هذا القسم للمعاملات. يمكنك إنهاء المعاملة بالنقر على الزر أدناه.",
  and: "و",
  email: "البريد الإلكتروني",
  mobile: "الهاتف المحمول",
  google: "Google"
};
